import { render, staticRenderFns } from "./invoiceView.vue?vue&type=template&id=3be4ef7c&scoped=true"
import script from "./invoiceView.vue?vue&type=script&lang=js"
export * from "./invoiceView.vue?vue&type=script&lang=js"
import style0 from "./invoiceView.vue?vue&type=style&index=0&id=3be4ef7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4ef7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be4ef7c')) {
      api.createRecord('3be4ef7c', component.options)
    } else {
      api.reload('3be4ef7c', component.options)
    }
    module.hot.accept("./invoiceView.vue?vue&type=template&id=3be4ef7c&scoped=true", function () {
      api.rerender('3be4ef7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/invoice/components/invoiceView.vue"
export default component.exports